import { Type } from 'class-transformer';
import { IsArray, IsEnum, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateNested } from 'class-validator';
import { BaseDto } from '../../../../@base/base.dto';
import { DiscussionId, PropertyId } from '../../../../types';

export class DiscussionParticipantDto {
  @IsString()
  @IsNotEmpty()
  participant!: string;

  @IsString()
  @IsNotEmpty()
  participantType!: 'agent' | 'seller' | 'owner' | 'user';

  @IsNumber()
  @IsNotEmpty()
  unreadCount!: number;

  @IsOptional()
  isStarred?: boolean;

  @IsOptional()
  isArchived?: boolean;

  @IsString()
  @IsOptional()
  firstName?: string;

  @IsString()
  @IsOptional()
  lastName?: string;

  @IsString()
  @IsOptional()
  avatarUrl?: string;

  @IsOptional()
  pinnedMessage?: unknown;
}

export class DiscussionDto extends BaseDto<DiscussionId> {
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => DiscussionParticipantDto)
  participants!: DiscussionParticipantDto[];

  @IsOptional()
  context?: {
    property?: PropertyId;
    application?: unknown;
  };

  @IsString()
  @IsOptional()
  lastMessageAt?: string;

  @IsString()
  @IsOptional()
  lastMessageText?: string;

  @IsEnum(['active', 'closed'])
  @IsNotEmpty()
  status!: 'active' | 'closed';
}
